import axios from 'axios';
import React, { useEffect, useState } from 'react';
import MoonLoader from 'react-spinners/MoonLoader';
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, ComposedChart, Bar, Label, LabelList, } from 'recharts';

function OverallAtt({ IP, TOKEN }) {

    const [isLoading, setLoading] = useState(false)
    const [kmitWeekwiseOverall, setKmitWeekwiseOverall] = useState([])
    const [ngitWeekwiseOverall, setNgitWeekwiseOverall] = useState([])

    const overallWeekwiseAttKMIT = async () => {
        setLoading(true)
        var parameters = { token: TOKEN, college: 'KMIT' }
        await axios.post(`http://${IP}/getoverallweekwiseattendance`, parameters)
            .then(res => {
                if (res.data.error === false) {
                    setKmitWeekwiseOverall(res.data.msg.weekwise)
                    setLoading(false)
                }
            })
            .catch(e => console.log(e))
    }

    const overallWeekwiseAttNGIT = async () => {
        setLoading(true)
        var parameters = { token: TOKEN, college: 'NGIT' }
        await axios.post(`http://${IP}/getoverallweekwiseattendance`, parameters)
            .then(res => {
                if (res.data.error === false) {
                    setNgitWeekwiseOverall(res.data.msg.weekwise)
                    setLoading(false)
                }
            })
            .catch(e => console.log(e))
    }

    useEffect(() => {
        overallWeekwiseAttKMIT()
    }, [])

    useEffect(() => {
        overallWeekwiseAttNGIT()
    }, [])


    return (
        <div>
            <div className='bg-white m-auto rounded mt-3 overall-chart mb-2' style={{ width: '90%', height: 300 }}>
                <div className='d-flex justify-content-between'>
                    <h6 className='ps-3 pt-3 py-2'>KMIT Weekwise Overall Attendance</h6>
                    {/* <div className='me-3'><span className='text-muted me-1'>Overall (%) : </span><h6 className='d-inline'>{}%</h6></div> */}
                </div>
                {
                    isLoading ?
                        <MoonLoader
                            className='mx-auto moonloader'
                            color="#012951"
                            loading={isLoading}
                            speedMultiplier={1}
                        />
                        :
                        <ResponsiveContainer>
                            <ComposedChart
                                data={kmitWeekwiseOverall}
                                margin={{ top: 15, bottom: 60 }}
                            >
                                <XAxis dataKey="name" fontSize={8} />
                                <YAxis fontSize={10} />
                                <Tooltip />
                                {/* <Legend /> */}
                                <Bar dataKey="avgattper" barSize={20} fill="#413ea0" >
                                    <LabelList dataKey="avgattper" position="top" fontSize={8} />
                                </Bar>
                                <Line type="monotone" dataKey="avgattper" stroke="#012951" activeDot={{ r: 8 }} />
                            </ComposedChart>
                        </ResponsiveContainer>
                }
            </div>

            <div className='bg-white m-auto rounded mt-3 overall-chart mb-2' style={{ width: '90%', height: 300 }}>
                <div className='d-flex justify-content-between'>
                    <h6 className='ps-3 pt-3 py-2'>NGIT Weekwise Overall Attendance</h6>
                    {/* <div className='me-3'><span className='text-muted me-1'>Overall (%) : </span><h6 className='d-inline'>{}%</h6></div> */}
                </div>
                {
                    isLoading ?
                        <MoonLoader
                            className='mx-auto moonloader'
                            color="#012951"
                            loading={isLoading}
                            speedMultiplier={1}
                        />
                        :
                        <ResponsiveContainer>
                            <ComposedChart
                                data={ngitWeekwiseOverall}
                                margin={{ top: 15, bottom: 60 }}
                            >
                                <XAxis dataKey="name" fontSize={8} />
                                <YAxis fontSize={10} />
                                <Tooltip />
                                {/* <Legend /> */}
                                <Bar dataKey="avgattper" barSize={20} fill="#413ea0" >
                                    <LabelList dataKey="avgattper" position="top" fontSize={8} />
                                </Bar>
                                <Line type="monotone" dataKey="avgattper" stroke="#012951" activeDot={{ r: 8 }} />
                            </ComposedChart>
                        </ResponsiveContainer>
                }
            </div>
        </div>
    );
}

export default OverallAtt;